import { createApp } from "vue";
import VueKonva from "vue-konva";
import App from "@/App.vue";
import axios from "axios";
import router from "@/router";
import store from "@/store";
import html2canvas from "html2canvas";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "@/css/style.css";

const app = createApp(App).use(store).use(router).use(VueKonva);

app.config.globalProperties.axios = axios;
app.config.globalProperties.html2canvas = html2canvas;

app.mount("#app");
